/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface IcfncErrors extends ng.IDirective {
    }

    interface IcfncErrorsScope extends ng.IScope {
        modelData: any;
        errorData: Array<any>;
        cssClass: string;
    }

    interface IcfncErrorsAttributes extends ng.IAttributes {
        cssClass: string;
    }


    class cfncErrors implements IcfncErrors {
        static directiveId: string = "cfncErrors";
        restrict: string = "EA";
        replace: boolean = false;
        scope: any = {
            modelData: "=",
            errorData: "="
        };
        template: string = "<div ng-class=\"cssClass\" ng-show=\"errorData.length > 0\"><div ng-repeat=\"error in errorData\">{{ error }}</div></div>";

        constructor() {
        }

        link = (scope: IcfncErrorsScope, element, attrs: IcfncErrorsAttributes) => {
            console.log(element);
            scope.cssClass = attrs.cssClass;
            scope.$watch("modelData", () => {
                scope.errorData = [];
            }, true);
        }
    }

    angular.module("app").directive(cfncErrors.directiveId, [() =>
        new cfncErrors()
    ]);
}